import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';
import { TabPanel, TabPanelProps } from '@material-ui/lab';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      '&:not([hidden])': {
        padding: 0,
      },
    },
    content: {
      position: 'relative',
      background: theme.palette.action.disabledBackground,
      padding: theme.spacing(1.5),
      borderRadius: theme.shape.borderRadius / 2,
      '&:not([hidden])': {
        padding: theme.spacing(1.5),
      },

      // for sections
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
  });

export interface ActivityItemTabPanelProps
  extends Omit<TabPanelProps, 'classes'>,
    WithStyles<typeof styles> {}

const ActivityItemTabPanel = ({
  classes,
  className,
  children,
  ...props
}: ActivityItemTabPanelProps) => {
  return (
    <TabPanel {...props} className={classNames(classes.root, className)}>
      <div className={classes.content}>{children}</div>
    </TabPanel>
  );
};

export default withStyles(styles)(ActivityItemTabPanel);
